<div class="field">
    <span class="label">{{ label() }}</span>
    <div class="options" [class.horizontal]="direction() === 'horizontal'">
        @for (option of options(); track option.value; let i = $index) {
            <div class="option">
                <cl-radiobutton [name]="name()" [value]="option.value" [formControl]="control()" [inputId]="inputId() + '_' + i" />
                <label [for]="inputId() + '_' + i">{{ option.label }}</label>
            </div>
        }
    </div>
    <app-form-error [errors]="control().errors" [visible]="control().touched && !!control().errors" />
</div>
